export const SITE_CONFIG = {
  siteName: 'DiscoXDiscos',
  whatsappNumber: '5492215464711',
  instagramUrl: 'https://www.instagram.com/discoxdiscos/',
  academyYoutubeUrl: 'https://www.youtube.com/@XACADEMIADEDJ',
};

export const buildWhatsAppUrl = (
  text = '',
  phoneNumber = SITE_CONFIG.whatsappNumber
) => {
  const cleanPhone = String(phoneNumber || '').replace(/\D/g, '');

  return `https://wa.me/${cleanPhone}${
    text ? `?text=${encodeURIComponent(text)}` : ''
  }`;
};